var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPromptIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "promptIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 11",
    cx: 48,
    cy: 48,
    r: 48,
    fill: "#E8F1FF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 9",
    cx: 47.999,
    cy: 48,
    r: 37.7705,
    fill: "#0754C8",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 10",
    cx: 47.7372,
    cy: 47.7382,
    r: 28.8525,
    fill: "#0754C8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.053 57.2859L41.3867 55.6196L57.5333 39.4141C58.0854 38.862 58.9806 38.862 59.5328 39.4141L60.1993 40.0806C60.7514 40.6328 60.7514 41.528 60.1993 42.0802L45.0525 57.2859C44.5004 57.838 43.6052 57.838 43.053 57.2859Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.7149 55.6192L45.0486 57.2854C44.4965 57.8376 43.6012 57.8376 43.0491 57.2854L36.4141 50.6504C35.862 50.0983 35.862 49.2031 36.4141 48.6509L37.0806 47.9844C37.6328 47.4323 38.528 47.4323 39.0802 47.9844L46.7149 55.6192Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromptIcon);
export default __webpack_public_path__ + "static/media/promptIcon.f0c5af42b4c70a8c02d986deb7ac543c.svg";
export { ForwardRef as ReactComponent };